// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1pdW8","addWidgetButton":"Header_addWidgetButton__3yoxv","dashboardTabs":"Header_dashboardTabs__2YR50","active":"Header_active__1JNrf"};